import { useAuth } from "core/context/AuthContext/AuthContextProvider";
import { convertNaNIntoNumber, formatAmount } from "core/utils/constants";
import { getCurrentDate, getCurrentDateAndTime } from "core/utils/constants/DateTime";
import React from "react";
import styled from "styled-components";
import classNames from "classnames";
import { PrintLegend } from "../StatusColorIndicator";

const styles: any = {
    left: {
        width: '100%',
        height: '100%',
        display: 'inline-block',
        float: 'left',
        margin: '10px 0 5px 0',
    },
    schoolDetails: {
        height: '2%',
        borderBottom: '2px solid #000',
    },
    secondDiv: {
        width: '100%',
    },
    total: {
        width: '100%',
        borderRight: '2px solid #ccc',
        height: '20%',
        display: 'inline-block',
    },
    date: {
        display: 'inline-block',
        float: 'right',
        marginRight: '1%',
    },
    feeParticulars: {
        borderTop: '2px solid #000',
        borderBottom: '2px solid #000',
        height: '38%',
    },
    tableHead: {
        height: '8%',
        border: '1px solid #000',
    },
    table: {
        borderCollapse: 'collapse',
        width: '100%',
    },
    hr: {
        opacity: 0.3,
    },
};

const TotalRecipt = ({ authData, data, colSpan = 8 }: any) => {
    const TOTAL_CASH_RECEIPT = data?.filter(item => item?.PAYMENT_MODE?.toUpperCase() === "CASH")?.reduce((sum, record) => sum + convertNaNIntoNumber(record?.AMOUNT), 0);
    const TOTAL_ONLINE_RECEIPT = data?.filter(item => item?.PAYMENT_MODE?.toUpperCase() === "ONLINE")?.reduce((sum, record) => sum + convertNaNIntoNumber(record?.AMOUNT), 0);
    return <tr>
        <th className="border-[1px] border-neutral-dark whitespace-nowrap px-2" align="right" colSpan={colSpan}>
            <h5 className="text-lg font-semibold" style={{ padding: 0, margin: 0 }}>CASH RECEIPTS:</h5><br />
            <h5 className="text-lg font-semibold" style={{ padding: 0, margin: 0 }}>ONLINE RECEIPTS:</h5>
            <div className="bg-neutral-dark h-[1px]" />
            <h5 className="text-lg font-semibold" style={{ padding: 0, margin: 0 }}>TOTAL RECEIPTS:</h5>
        </th>
        <th className="border-[1px] border-neutral-dark whitespace-nowrap px-2" align="right">
            <h5 className="text-lg font-semibold" style={{ padding: 0, margin: 0 }}>{formatAmount(authData, TOTAL_CASH_RECEIPT || 0)}</h5><br />
            <h5 className="text-lg font-semibold" style={{ padding: 0, margin: 0 }}>{formatAmount(authData, TOTAL_ONLINE_RECEIPT) || 0}</h5>
            <div className="bg-neutral-dark h-[1px]" />
            <h5 className="text-lg font-semibold" style={{ padding: 0, margin: 0 }}>{formatAmount(authData, TOTAL_CASH_RECEIPT + TOTAL_ONLINE_RECEIPT)}</h5>
        </th>
    </tr>
}

const AccountTransactionCategoryWise = ({ aT }) => {
    const [printReady, setPrintReady] = React.useState<boolean>(false);

    const authData = useAuth();

    React.useEffect(() => {
        if (aT && Object.keys(aT)?.length > 0) {
            setPrintReady(true);
        }
    }, [aT]);

    return (
        <div className="bg-neutral-light print:px-1">
            <div className="flex justify-between items-center bg-neutral-light p-4 gap-4 print:hidden">
                {/* legend component */}
                <PrintLegend />
                {!!printReady && <button className='bg-primary-main text-neutral-light px-4 py-1 rounded-lg' onClick={() => window.print()}>Print</button>}
            </div>
            <table style={{ ...styles.table, borderBottom: 'none' }}>
                <tbody>
                    <tr>
                        <td>

                            <div className="flex justify-between items-center py-10">
                                <img src={authData?.BRANCH_LOGO} alt="" className="object-fit max-h-[100px]" />
                                <h3 className="text-4xl font-bold">{authData?.INSTITUTE_NAME?.toUpperCase()}</h3>
                                <div className="object-fit min-w-[100px]"></div>
                            </div>
                            <hr />
                            <h4 className="py-10 text-lg font-bold" style={{ textAlign: 'center' }}>
                                CASH BOOK - {getCurrentDateAndTime(new Date(), true)} <br />
                                ACADEMIC YEAR: {authData?.SELECTED_ACADEMIC_YEAR?.NAME}<br />
                                FROM {getCurrentDate(aT?.SELECTED_START_DATE)} TO {getCurrentDate(aT?.SELECTED_END_DATE)}
                            </h4>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <div style={styles.left}>
                                <table style={{ ...styles.table, borderBottom: '1px solid #888' }}>
                                    <thead style={styles.tableHead}>
                                        <tr className="border-[1px] border-neutral-dark">
                                            <th className="p-[5px] font-bold text-lg" colSpan={11}>FEE RECEIPTS</th>
                                        </tr>
                                        <tr>
                                            <th className="border-[1px] border-neutral-dark p-[5px] font-bold text-lg">#</th>
                                            <th className="border-[1px] border-neutral-dark p-[5px] font-bold text-lg">Receipt No</th>
                                            <th className="border-[1px] border-neutral-dark p-[5px] font-bold text-lg">Staff Name</th>
                                            <th className="border-[1px] border-neutral-dark p-[5px] font-bold text-lg">Student Name</th>
                                            <th className="border-[1px] border-neutral-dark p-[5px] font-bold text-lg">Category</th>
                                            <th className="border-[1px] border-neutral-dark p-[5px] font-bold text-lg">Class</th>
                                            <th className="border-[1px] border-neutral-dark p-[5px] font-bold text-lg">Date</th>
                                            <th className="border-[1px] border-neutral-dark p-[5px] font-bold text-lg">Payment Type</th>
                                            <th className="border-[1px] border-neutral-dark p-[5px] font-bold text-lg">Student Status</th>
                                            <th className="border-[1px] border-neutral-dark p-[5px] font-bold text-lg">Remarks</th>
                                            <th className="border-[1px] border-neutral-dark p-[5px] font-bold text-lg">Amount</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {aT?.FeePaymentList?.map((item, i) => {
                                            const status = item?.DisplayStudentClassStatus?.toUpperCase();
                                            const rowBg = classNames({
                                                'bg-yellow-300 print:bg-yellow-300 !print-color-adjust-exact': status === 'INACTIVE',
                                                'line-through text-gray-400 print:line-through print:text-gray-400': status === 'DELETED'
                                            });
                                            return <tr key={"FeePaymentList" + i} className={rowBg}>
                                                <th className="border-[1px] border-neutral-dark p-[5px] text-xl font-semibold">{i + 1}</th>
                                                <th className="border-[1px] border-neutral-dark p-[5px] text-xl font-semibold">{item?.BILL_NUMBER || "-"}</th>
                                                <th className="border-[1px] border-neutral-dark p-[5px] text-xl font-semibold">{item?.Staff || "-"}</th>
                                                <th className="border-[1px] border-neutral-dark p-[5px] text-xl font-semibold">{item?.StudentName || "-"}</th>
                                                <th className="border-[1px] border-neutral-dark p-[5px] text-xl font-semibold">{item?.HeadCategoryName || "-"}</th>
                                                <th className="border-[1px] border-neutral-dark p-[5px] text-xl font-semibold">{item?.ClassName || "-"}</th>
                                                <th className="border-[1px] border-neutral-dark p-[5px] text-xl font-semibold">{!!item?.PAYMENT_DATETIME ? getCurrentDateAndTime(item?.PAYMENT_DATETIME, true) : !!item?.TRANSACTION_DATETIME ? getCurrentDateAndTime(item?.TRANSACTION_DATETIME, true) : "-"}</th>
                                                <th className="border-[1px] border-neutral-dark p-[5px] text-xl font-semibold">{item?.PAYMENT_MODE || "-"}</th>
                                                <th className="border-[1px] border-neutral-dark p-[5px] text-xl font-semibold">{item?.DisplayStudentClassStatus || "-"}</th>
                                                <th className="border-[1px] border-neutral-dark p-[5px] text-xl font-semibold">{item?.REMARK || "-"}</th>
                                                <th className="border-[1px] border-neutral-dark py-[5px] text-xl font-semibold text-right">{formatAmount(authData, item?.AMOUNT) || 0}</th>
                                            </tr>
                                        })}
                                        <TotalRecipt data={aT?.FeePaymentList} colSpan={10} />
                                    </tbody>
                                </table>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
}

export default AccountTransactionCategoryWise;